<!-- Each row is a grid of its own, so the cards of a row share a height without a short card in
     one row waiting for a tall card in the other. Beside the sidebar three cards only fit from xl,
     so up to xl the Devices card takes the width under Address and Ownership, and the second row
     stacks. Below md every card takes the full width. -->
<div class="flex flex-col gap-6">
  <div class="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
    <xemex-card [title]="'installations.general.address' | translate" [fill]="true">
      <!-- The button is taller than the card title. The negative margin keeps it from growing the
           header, so this title lines up with the titles of the other cards in the row. -->
      @if (canPlaceOnMap()) {
        <xemex-text-button
          cardHeaderActions
          class="-my-2"
          icon="edit_location_alt"
          iconPosition="end"
          (click)="placeOnMap()"
        >
          {{ 'locations.coordinates.placeOnMap' | translate }}
        </xemex-text-button>
      }
      <div class="flex flex-col gap-4">
        <xemex-detail-field [label]="'installations.general.street' | translate">
          @if (street()) {
            <a
              class="text-text-default hover:underline"
              data-testid="installation-street"
              [routerLink]="['/', APP_PATHS.Locations, installation().location.locationId]"
              >{{ street() }}</a
            >
          }
        </xemex-detail-field>
        <div class="grid grid-cols-2 gap-4">
          <xemex-detail-field [label]="'installations.general.postalCode' | translate">
            {{ installation().location.postalCode }}
          </xemex-detail-field>
          <xemex-detail-field [label]="'locations.table.city' | translate">
            {{ installation().location.city }}
          </xemex-detail-field>
        </div>
        <xemex-detail-field [label]="'locations.table.country' | translate">
          {{ country() }}
        </xemex-detail-field>
        <xemex-detail-field [label]="'installations.general.timezone' | translate">
          <span data-testid="installation-timezone">{{ installation().timezone }}</span>
        </xemex-detail-field>

        <div class="h-40 overflow-hidden rounded-lg border border-border-default">
          @if (hasCoordinates()) {
            <xemex-branches-map
              height="160px"
              [latitude]="installation().location.latitude!"
              [longitude]="installation().location.longitude!"
            />
          } @else {
            <div
              class="flex h-full items-center justify-center bg-surface-page text-sm text-text-secondary"
              data-testid="no-coordinates"
            >
              {{ 'locations.message.noCoordinates' | translate }}
            </div>
          }
        </div>
      </div>
    </xemex-card>

    <xemex-installation-ownership-card [installation]="installation()" [devices]="feeding()" />

    <xemex-installation-devices-card
      class="md:col-span-2 xl:col-span-1"
      [installation]="installation()"
      [devices]="devices()"
      [detailsLoading]="devicesLoading()"
      [showAttributes]="showAttributes()"
      (bindingsChanged)="reloadBindings()"
      (deviceLinked)="reloadAfterLink()"
      (profileRequested)="showProfile()"
      (installationChanged)="reloadInstallation()"
    />
  </div>

  <div class="grid grid-cols-1 gap-6 xl:grid-cols-2">
    <xemex-installation-measurement-points-card [installation]="installation()" />

    <xemex-card
      data-testid="activities-card"
      [title]="'installations.general.activities' | translate"
      [fill]="true"
      [actionLabel]="canOpenTabs() ? ('general.btnViewAll' | translate) : undefined"
      [actionIcon]="canOpenTabs() ? 'arrow_forward' : undefined"
      (action)="openActivity()"
    >
      @if (canOpenTabs()) {
        <xemex-installation-recent-activity
          [installationOid]="installationOid()"
          [devices]="feeding()"
          [locationDevices]="locationDevices()"
        />
      } @else {
        <div class="py-6 text-center text-text-secondary" data-testid="activity-empty">
          <xemex-installation-activity-empty [devices]="feeding()" />
        </div>
      }
    </xemex-card>
  </div>
</div>
